export const PowerIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 2C13 1.44772 12.5523 1 12 1C11.4477 1 11 1.44772 11 2V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V2Z"
        fill="currentColor"
      />
      <path
        d="M6.33734 7.34664C6.7278 6.95605 6.7277 6.32289 6.33711 5.93243C5.94653 5.54197 5.31336 5.54207 4.9229 5.93266C3.5247 7.33131 2.57262 9.11315 2.18703 11.0529C1.80144 12.9926 1.99967 15.0031 2.75664 16.8302C3.51361 18.6572 4.79534 20.2188 6.43976 21.3175C8.08418 22.4162 10.0174 23.0026 11.9951 23.0026C13.9728 23.0026 15.9061 22.4162 17.5505 21.3175C19.1949 20.2188 20.4766 18.6572 21.2336 16.8302C21.9906 15.0031 22.1888 12.9926 21.8032 11.0529C21.4176 9.11315 20.4655 7.33131 19.0673 5.93266C18.6769 5.54207 18.0437 5.54197 17.6531 5.93243C17.2625 6.32289 17.2624 6.95605 17.6529 7.34664C18.7715 8.46556 19.5331 9.89103 19.8416 11.4428C20.1501 12.9946 19.9915 14.603 19.3859 16.0646C18.7803 17.5263 17.7549 18.7756 16.4394 19.6545C15.1239 20.5334 13.5773 21.0026 11.9951 21.0026C10.413 21.0026 8.86637 20.5334 7.55083 19.6545C6.23529 18.7756 5.20991 17.5263 4.60434 16.0646C3.99876 14.603 3.84018 12.9946 4.14865 11.4428C4.45712 9.89103 5.21879 8.46556 6.33734 7.34664Z"
        fill="currentColor"
      />
    </svg>
  );
};
